import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const FeatureReadinessStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({
    stepRun,
}) => {
    return <div>Feature Readiness Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
